// material-ui
import { Avatar, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// project imports
import { IconMenu2 } from "@tabler/icons";
import { useDispatch, useSelector } from "../../../store";
import { openDrawer } from "../../../store/slices/menu";
import ProfileSection from "./ProfileSection";


// ==============================|| MAIN NAVBAR / HEADER ||============================== //


const Header = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: "flex",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
          backgroundColor: '#c1eafe'
        }}
      >

        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            overflow: 'hidden',
            transition: 'all .2s ease-in-out',
            background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
            color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
            '&:hover': {
              background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
              color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
            }
          }}
          onClick={() => dispatch(openDrawer(!drawerOpen))}
          color="inherit"
        >
          <IconMenu2 stroke={1.5} size="20px" />
        </Avatar>
      </Box>

      {/* header search */}
      {/* <SearchSection /> */}
      <Box
        sx={{
          paddingLeft: "50px",
          [theme.breakpoints.down("sm")]: {
            display: "none",
          },
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: 500, color: "#004085" }}>
          Phần mềm Quản lí Thư viện - Liên thông Thư viện GD Lib
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  );
};

export default Header;
